import { render, staticRenderFns } from "./ElemChart.vue?vue&type=template&id=0ab4b612&scoped=true&"
import script from "./ElemChart.vue?vue&type=script&lang=js&"
export * from "./ElemChart.vue?vue&type=script&lang=js&"
import style0 from "./ElemChart.vue?vue&type=style&index=0&id=0ab4b612&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab4b612",
  null
  
)

export default component.exports